import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { getBanners } from './mapper';

export const bannerQueryKey = createQueryKeys('banners', {
  list: {
    queryFn: async () => {
      const data = await getBanners();
      return data;
    },
    queryKey: null,
  },
});

export type BannerQueryKey = inferQueryKeys<typeof bannerQueryKey>;
